<ul class="to_do">
  <!--<ng-content select="ap-checklist-item"></ng-content>-->
  @for (item of items; track item) {
    <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
  }
</ul>
@if (items && items.length == 0) {
  <div>
    <ng-content select="ap-checklist-empty"></ng-content>
  </div>
}